import {Component, inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CompliancePlan} from '@core/types';
import {ModalService, PlanService} from '@core/services';

@Component({
  selector: 'core-plan-identification-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './plan-identification-form.html',
  host: {
    style: 'width: 100%;display: flex;flex-direction: column;gap: 1.25rem;padding: 0 1.5rem 1.5rem'
  }
})
export class PlanIdentificationForm implements OnInit {
  @Input() plan: CompliancePlan | null = null;

  form: FormGroup;
  isSubmitting = false;
  errorMessage = '';

  private readonly modal = inject(ModalService);
  private readonly planService = inject(PlanService);
  private readonly formBuilder = inject(FormBuilder);

  constructor() {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      description: [''],
      goals: ['']
    });
  }

  ngOnInit(): void {
    if (!this.plan) return;
    this.form.patchValue({
      name: this.plan.name || '',
      description: this.plan.description || '',
      goals: this.plan.goals || ''
    });
  }

  async submit() {
    if (this.isSubmitting) return;
    if (!this.plan?.id) {
      this.errorMessage = 'No se encontró el plan activo.';
      return;
    }
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';
    const value = this.form.value;

    const response = await this.planService.updatePlan(this.plan.id, {
      name: value.name,
      description: value.description || undefined,
      goals: value.goals || undefined
    });
    this.isSubmitting = false;

    if (!response.success) {
      this.errorMessage = response.message || 'No se pudo actualizar la identificación del plan.';
      return;
    }

    this.modal.closeTop(response.result || true);
  }

  close() {
    this.modal.closeTop(false);
  }
}
